export const productReport = {
	title: "Informe delivery por producto",
	columns: {
		name: "Producto",
		sku: "SKU",
		count: "Cantidad",
		totalValue: "Precio total",
		baseValue: "Precio base",
		integration: "Integración",
	},
	vendors: {
		coala: "Whitelabel",
		ifood: "Ifood",
		rappi: "Rappi",
		ubereats: "Uber eats",
	},
	sheet: {
		filename: "informe-delivery",
		generalProductReport: {
			title: "Informe de productos delivery",
			columns: {
				name: "Producto",
				sku: "SKU",
				count: "Cantidad",
				totalValue: "Precio total",
				baseValue: "Precio base",
				integration: "Integración",
			},
		},
		allOrdersProductsReport: {
			title: "Informe de pedidos de productos",
			columns: {
				name: "Producto",
				sku: "SKU",
				count: "Cantidad",
				baseUnitPrice: "Precio base",
				totalUnitPrice: "Precio total",
				obs: "Observación",
				deliveryOrderId: "Identificador de la orden",
				productId: "Identificador del producto",
			},
		},
	},
};
